import { fetchApi } from '@/config/axiosSetting.ts';
import {
  getIncidentCardDetailsInfoBodyPropsType,
  IncidentCardDetailsInfoBodyResType,
} from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/body/getIncidentCardDetailsInfoBody.types';

const getIncidentCardDetailsInfoBody = ({
  id,
}: getIncidentCardDetailsInfoBodyPropsType): Promise<IncidentCardDetailsInfoBodyResType> => {
  return fetchApi({
    method: 'GET',
    url: `/body/reports/${id}/accident_information/`,
  });
};

export default getIncidentCardDetailsInfoBody;
